<template>
  <div>
    <audio
    ref="tada"
    src="/sounds/success.m4a"
    type="audio/x-m4a"
  />
  <audio
    ref="tada2"
    src="/sounds/tada2.flac"
    type="audio/x-m4a"
  />
  </div>

</template>
<script>
// const SOUND_EFFECTS = {
//   tada: '/sounds/success.m4a',
//   tada2: '/sounds/tada2.flac'
// }

export default {
  data () {
    return {
      sound: 'tada'
    }
  },
  watch: {
    '$store.getters.soundEffect': {
      immediate: false,
      handler (soundEffect) {
        console.log('soundEffect', soundEffect)

        if (soundEffect.sound !== this.sound) {
          this.sound = soundEffect.sound
        }

        this.play()
      }
    }
  },
  methods: {
    play () {
      this.$refs[this.sound].cloneNode(true).play()
    }
  }
}
</script>
